/**
 * TaskStreamingService
 * Handles chunked loading of tasks using server-side pagination (Skip/Take).
 * The backend supports Skip/Take on TaskReportFilterModel and MyTaskFilterModel.
 */
import { TaskService } from './TaskService';
export class TaskStreamingService {
    constructor(http) {
        this.taskService = new TaskService(http);
    }
    /**
     * Stream tasks using server-side pagination.
     * Each yield returns one page of results.
     */
    async *streamTasks(filter, chunkSize = 50) {
        let skip = 0;
        let hasMore = true;
        while (hasMore) {
            const pageFilter = {
                ...filter,
                skip,
                take: chunkSize,
            };
            const response = await this.taskService.listViewRaw(pageFilter);
            const items = response.data ?? [];
            if (items.length > 0) {
                yield items;
            }
            // Check if there are more pages
            if (response.hasMore === false || items.length < chunkSize) {
                hasMore = false;
            }
            else {
                skip += chunkSize;
            }
        }
    }
    /**
     * Stream admin tasks using server-side pagination.
     */
    async *streamAdminTasks(filter, chunkSize = 100) {
        let skip = 0;
        let hasMore = true;
        while (hasMore) {
            const pageFilter = {
                ...filter,
                skip,
                take: chunkSize,
            };
            const response = await this.taskService.getAdminListViewRaw(pageFilter);
            const items = response.data ?? [];
            if (items.length > 0) {
                yield items;
            }
            if (response.hasMore === false || items.length < chunkSize) {
                hasMore = false;
            }
            else {
                skip += chunkSize;
            }
        }
    }
    /**
     * Stream user's created tasks.
     */
    async *streamMyCreatedTasks(filter, chunkSize = 50) {
        // Created tasks don't support server pagination yet - fetch all and chunk client-side
        const tasks = await this.taskService.getMyCreatedTasks(filter);
        for (let i = 0; i < tasks.length; i += chunkSize) {
            yield tasks.slice(i, i + chunkSize);
        }
    }
    /**
     * Load all tasks with progress callback.
     */
    async loadAllWithProgress(filter, chunkSize = 50, onProgress) {
        const allTasks = [];
        for await (const chunk of this.streamTasks(filter, chunkSize)) {
            allTasks.push(...chunk);
            onProgress?.(allTasks.length, allTasks.length);
        }
        return allTasks;
    }
    /**
     * Load admin tasks with progress callback.
     */
    async loadAdminAllWithProgress(filter, chunkSize = 100, onProgress) {
        const allTasks = [];
        for await (const chunk of this.streamAdminTasks(filter, chunkSize)) {
            allTasks.push(...chunk);
            onProgress?.(allTasks.length, allTasks.length);
        }
        return allTasks;
    }
}
//# sourceMappingURL=TaskStreamingService.js.map